// Third party
import React, { Component } from 'react';

// Components
import { withErrorBoundary } from '../errors';

// Utils
import { populateBenchmarkFilters } from '../../../utils/advanced-search';
import AdvancedSearchInput from './AdvancedSearchInput';
import { formatMessage } from '../../../utils/i18n';
import SearchOptions from '@/types/search-options';
import BenchmarkFiltersData from '@/types/benchmark-filters-data';
import FilterType from '@/types/filter-type';

interface Props {
  onBenchmarkSearch: (options: SearchOptions) => void;
  clearPreLoadQuery: (query: string) => void;
  filtersData: BenchmarkFiltersData;
  hasData?: boolean;
  loadingFilters?: boolean;
  preLoadQuery?: string;
  minimizedFiltersToShow?: number;
  loadingResults?: boolean;
}

class BenchmarkSearchInput extends Component<Props> {
  getFilters = (): FilterType[] => populateBenchmarkFilters(this.props.filtersData);

  render() {
    const { loadingFilters, hasData, preLoadQuery, minimizedFiltersToShow, loadingResults } = this.props;
    const loadingProps = { loadingFilters, loadingResults };

    return (
      <AdvancedSearchInput
        {...loadingProps}
        className="benchmark-search-input"
        filters={this.getFilters()}
        placeholder="Search.Benchmarks.Placeholder"
        buttonLabel="Search.Benchmarks.Apply"
        onSearch={this.props.onBenchmarkSearch}
        clearPreLoadQuery={this.props.clearPreLoadQuery}
        preLoadQuery={preLoadQuery}
        placeholderText={formatMessage('Search.Benchmarks.Placeholder')}
        applySearchText={formatMessage(`Search.${loadingResults ? 'Searching' : 'Benchmarks.Apply'}`)}
        minimizedFiltersToShow={minimizedFiltersToShow}
        hasData={hasData}
      />
    );
  }
}

export default withErrorBoundary(BenchmarkSearchInput);
